import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Button, Container, ListGroup, ListGroupItem } from "reactstrap";
import Header from "../../../component/Header";
import RiskTitle from "../YourResult/RiskTitle";
import { AppContext } from "../../../context/app-context";
import { sendFirebaseEvent } from "../../../helper/mobile";

const YourScore = () => {
    const [state, dispatch] = useContext(AppContext);
    const data = state.riskAssessment.preRiskAssessment;
    const questionList = ele => {
        let label = '';
        if(ele.questionerLabel === 'gestational_diabetes')
            label = 'Gestational diabetes';
        else if(ele.questionerLabel === 'family_diabieties_history')
            label = 'Family history of sugar';
        else if(ele.questionerLabel === 'high_blood_pressure')
            label = 'High blood pressure';
        else if(ele.questionerLabel === 'physically_active')
            label = 'Physically active';

        return <ListGroupItem key={ele.questionerLabel}>{label} <span className="float-end text-capitalize">{ele.responseText}</span></ListGroupItem>
    }
    return(
      <>
        <Header title="Risk score" howToMeasure={true} />
        <Container className="your-score">
          <RiskTitle score={data.assessmentScore} />
          <ListGroup flush className="mt-4">
            <ListGroupItem>Gender <span className="float-end text-capitalize">{state.user.gender}</span></ListGroupItem>
            {data.questionerResponse.map(element => questionList(element))}
            <ListGroupItem>Calculated BMI <span className="float-end">{data.userInfo.bmi}</span></ListGroupItem>
          </ListGroup>
          <div className="empty-space-82"></div>
          <div className="fix-div-button">
            <Link to="/riskAssessment/question/userDetails" onClick={() => sendFirebaseEvent('ra_test_again_btn_click', 'click_event')}>
              <Button className="risk-btn">Test again</Button>
            </Link>
          </div>
        </Container>
      </>
    )
}

export default YourScore